/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.DocTypeSelector";
        const ID_ATTRIBUTE = "data-id";
        class ComponentDocTypeSelector extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, upload, multiSelect = false, include = [], exclude = []) {
                super(core, container, parent);
                // Data
                this._docTypeGroups = [];
                this._currentGroup = -1;
                // UI Elements
                this._form = null;
                this._dtgSelectHolder = null;
                this._multiSelectLabel = null;
                this._multiSelectNumLabel = null;
                this._docTypeDataListContainer = null;
                this._includeList = null;
                this._excludeList = null;
                // Components
                this._docTypeDataList = null;
                this._optionInput = null;
                this._docTypeGroupOptions = null;
                // Configuration
                this._uploadMode = false;
                this._multiSelect = false;
                this.SelectionCallback = null;
                this._storeHtml = (htmlData) => {
                    ComponentDocTypeSelector.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._populateInternalData = () => {
                    // Doc typs lists may differ between upload mode and normal mode
                    if (this._uploadMode) {
                        this._docTypeGroups = this._core.OBHelper.UploadDocumentTypeGroups;
                    }
                    else {
                        this._docTypeGroups = this._core.OBHelper.DownloadDocumentTypeGroups;
                    }
                    this._populateGroupList();
                };
                this._populateGroupList = () => {
                    // Stick a blank option in at the top of the list
                    this._docTypeGroupOptions = {
                        Items: []
                    };
                    let blankOption = {
                        Id: '-1',
                        DisplayName: `<<${this._core.Locale.getTranslation('STR_WPT_ALL')}>>`
                    };
                    this._docTypeGroupOptions.Items.push(blankOption);
                    // Populate the rest of the options.
                    this._docTypeGroups.forEach(group => {
                        let groupOption = {
                            Id: group.Id.toString(10),
                            DisplayName: group.TranslatedName
                        };
                        this._docTypeGroupOptions.Items.push(groupOption);
                    });
                    this._optionInput.Options = this._docTypeGroupOptions;
                    this._optionInput.Input.value = this._docTypeGroupOptions.Items[0].DisplayName;
                    // Select the current group and populate
                    this._currentGroup = -1;
                    this._populateTypeList(null);
                };
                this._populateTypeList = (event) => {
                    this._docTypeDataList.clearList();
                    let dataItems = { Items: [] };
                    let insertList = (this._uploadMode) ? this._core.OBHelper.UploadDocumentTypes : this._core.OBHelper.DownloadDocumentTypes;
                    if (this._currentGroup > -1) {
                        insertList = insertList.filter(dt => dt.Group.Id == this._currentGroup);
                    }
                    for (let i = 0; i < insertList.length; i++) {
                        let dt = insertList[i];
                        if (dt.HideFromList)
                            continue;
                        if ((this._includeList.length > 0) && (this._includeList.indexOf(dt.Name) == -1))
                            continue;
                        if ((this._excludeList.length > 0) && (this._excludeList.indexOf(dt.Name) != -1))
                            continue;
                        dataItems.Items.push({ Id: dt.Id.toString(), DisplayName: this._core.OBHelper.getDocTypeAlias(dt.Name, dt.TranslatedName) });
                    }
                    this._docTypeDataList.displayData(dataItems);
                };
                this._groupSelected = (event) => {
                    this._log.info("ComponentDocTypeSelector._groupSelected()");
                    let displayValue = this._optionInput.Input.value;
                    let selectedDocTypeGroup = this._docTypeGroupOptions.Items.find(opt => opt.DisplayName == displayValue);
                    this._currentGroup = -1;
                    if (selectedDocTypeGroup) {
                        this._currentGroup = Number(selectedDocTypeGroup.Id);
                    }
                    this._populateTypeList(null);
                    if (this.SelectionCallback)
                        this.SelectionCallback([]);
                };
                // Called when we get an item checked or otherwise
                this._docTypeClicked = (id, selected) => {
                    if (this._log.isTraceEnabled) {
                        this._log.trace(`ComponentDocTypeSelector::_docTypeClicked got ID ${id}, selected ${selected}`);
                    }
                    if (this._multiSelect) {
                        if (selected)
                            this._docTypeDataList.deSelectItem(id);
                        else
                            this._docTypeDataList.selectItem(id);
                        if (this._docTypeDataList.SelectedItems.length > 0) {
                            this._multiSelectNumLabel.innerText = `(${this._docTypeDataList.SelectedItems.length} ${this._core.Locale.getTranslation('STR_WPT_LABEL_SELECTED')})`;
                            this._core.Functions.showElement(this._multiSelectLabel);
                        }
                        else
                            this._core.Functions.hideElement(this._multiSelectLabel);
                        if (this.SelectionCallback)
                            this.SelectionCallback(this._docTypeDataList.SelectedItems);
                    }
                    else {
                        // Don't want to mess if we're re-clicking an already-selected item
                        if (this._docTypeDataList.SelectedItems.indexOf(id) == -1) {
                            this._docTypeDataList.clearItemSelection();
                            this._docTypeDataList.selectItem(id);
                            if (this.SelectionCallback)
                                this.SelectionCallback(this._docTypeDataList.SelectedItems);
                        }
                    }
                };
                this._deselectAllDocTypes = () => {
                    this._log.info("ComponentDocTypeSelector._deselectAllDocTypes()");
                    this._docTypeDataList.clearItemSelection();
                    this._core.Functions.hideElement(this._multiSelectLabel);
                    if (this.SelectionCallback)
                        this.SelectionCallback([]);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DataListComponent::constructor");
                this._uploadMode = upload;
                this._multiSelect = ((upload == false) && multiSelect); // Can't multiselect if uploading
                this._includeList = (include != null) ? include : [];
                this._excludeList = (exclude != null) ? exclude : [];
                if (!ComponentDocTypeSelector.Html) {
                    core.Loader.getVersionedHTML('widgets/components/doctypeselector.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            get MultiSelect() {
                return this._multiSelect;
            }
            set MultiSelect(value) {
                this._multiSelect = value;
            }
            get SelectedDocTypes() {
                return this._docTypeDataList.SelectedItems;
            }
            _present() {
                if (!this._readyToPresent) {
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentDocTypeSelector.Html;
                this._form = this._container.querySelector('#dtsForm');
                this._form.id = `dtsForm_${this._core.Functions.UniqueNumber}`;
                this._dtgSelectHolder = this._container.querySelector('#dtsDTGSelectHolder');
                this._docTypeDataListContainer = this._container.querySelector('#dtsDTDataListContainer');
                this._multiSelectLabel = this._container.querySelector('#dtsDTGSelectedLabel');
                this._multiSelectNumLabel = this._container.querySelector('#dtsDTGNumSelectedLabel');
                this._core.Helper.setElementTranslation(this._container.querySelector('#dtsDTGLabel'), 'STR_WPT_DOCTYPEGROUP');
                this._core.Helper.setElementTranslation(this._container.querySelector('#dtsDTLabel'), 'STR_WPT_DOCTYPE');
                this._container.querySelector('#dtsDTGDeselectIcon').addEventListener('click', this._deselectAllDocTypes);
                this._docTypeGroupOptions = {
                    Items: []
                };
                let optionConfig = {
                    Options: this._docTypeGroupOptions,
                    ValueMustExist: true,
                    AllowEmptyValue: false,
                    ChangeCallback: this._groupSelected
                };
                this._optionInput = new Widgets.ComponentOptionInput(this._core, this._dtgSelectHolder, this._parent, optionConfig);
                this._optionInput.present();
                this._optionInput.Input.id = "dtsDTGSelect";
                this._docTypeDataList = new Widgets.ComponentDataList(this._core, this._docTypeDataListContainer, this._parent, { SelectItemCallback: this._docTypeClicked });
                this._docTypeDataList.present();
                if (this._uploadMode) {
                    this._core.OBHelper.LoadUploadDocumentTypes(this._populateInternalData);
                }
                else {
                    this._core.OBHelper.LoadDownloadDocumentTypes(this._populateInternalData);
                }
            }
        }
        ComponentDocTypeSelector.Html = null;
        Widgets.ComponentDocTypeSelector = ComponentDocTypeSelector;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
